<div class="glxy-file-progress-indicator">
  @switch (status) {
    @case (FileUploadStatus.Queued) {
      <mat-icon class="status-icon"> attach_file </mat-icon>
    }
    @case (FileUploadStatus.Fail) {
      <mat-icon class="fail-icon status-icon"> warning </mat-icon>
    }
    @case (FileUploadStatus.Success) {
      <mat-icon class="success-icon status-icon"> done </mat-icon>
    }
    @case (FileUploadStatus.InProgress) {
      <mat-spinner [diameter]="20" />
    }
  }
</div>
